'use strict';

import Hammer from 'hammerjs';

const animateCls = 'is-animated';
const ngAnimateClass = 'is-ngAnimationEnabled';
const containerStyles = {
  position: 'relative',
  width: '100%',
  height: '100%',
  overflow: 'hidden'
};
const stackContainerStyles = {
  position: 'relative',
  width: '100%',
  height: '100%'
};
const itemStyles = {
  display: 'inline-block',
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0
};
const stackItemStyles = {
  display: 'inline-block',
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0
};

const saCarouselCtrl = function ($q, $animate, $window, $scope, $attrs, $element, preventClick) {
  'ngInject';

  const options = $scope.$eval($attrs.saCarouselOptions) || {};
  var containerElement;
  var isInitialized;
  var eventManager;

  function getSlideTransform(index, offset) {
    var translateX = index * 100 + offset;
    var opacity = 1 - Math.abs(translateX) / 200;
    var styles = { opacity: opacity };

    styles['-webkit-transform'] = 'translate3d(' + (translateX + '%') + ', 0, 0) scale3d(1, 1, 1)';
    styles['transform'] = 'translate3d(' + (translateX + '%') + ', 0, 0) scale3d(1, 1, 1)';

    return styles;
  }

  function setOffset(items, offset, animate) {
    containerElement.removeClass(animateCls);

    if (animate) {
      containerElement.addClass(animateCls);
    }

    items.forEach(function (item, index) {
      item.css(getSlideTransform(index, offset));
    });
  }

  this.panHandler = function (event) {
    var currentItemIndex = this.currentItemIndex;
    var deltaX = event.deltaX;
    var speedConstant = 1;
    var pageWidth = containerElement[0].offsetWidth;
    var offset;

    if (event.type === 'panend') {
      preventClick(event.srcEvent);

      if (Math.abs(deltaX) < pageWidth / 8) {
        this.showItem(currentItemIndex);
      } else {

        if (event.deltaX < 0) {
          this.nextItem();
        } else {
          this.prevItem();
        }
      }
    } else {

      // Slow down on first and last items
      if (currentItemIndex === 0 && deltaX < 0 || currentItemIndex === this.items.length - 1 && deltaX > 0) {
        speedConstant = 0.3;
      }

      offset = -100 * currentItemIndex + event.deltaX / pageWidth * 100 * speedConstant;

      setOffset(this.items, offset);
    }
  };

  // initialization

  this.currentItemIndex = 0;
  this.items = [];
  this.isEnabled = !$attrs['saCarousel'];

  this.init = function () {
    if (isInitialized || !containerElement || this.isEnabled === false) {
      return;
    }

    if (!options.stack) {
      eventManager = new Hammer($element[0], {
        recognizers: [
          [Hammer.Swipe, { direction: Hammer.DIRECTION_HORIZONTAL }],
          [Hammer.Pan, { direction: Hammer.DIRECTION_HORIZONTAL, threshold: 30 }]
        ]
      });

      eventManager.on('panleft panright panend', (event) => {
        $scope.$apply(() => {
          this.panHandler(event);
        });
      });
    }

    if (containerElement) {
      containerElement.css(options.stack ? stackContainerStyles : containerStyles);
    }

    this.items.forEach(function (item, index) {
      item.css(itemStyles);
      if (options.stack) {
        item.css({
          'opacity': 0,
          'z-index': index
        });
      }
    });
    this.showItem(0);

    isInitialized = true;
  };

  this.destroy = function () {
    if (isInitialized === false) {
      return;
    }

    if (eventManager) {
      eventManager.destroy();
      eventManager = null;
    }

    if (containerElement) {
      containerElement.removeAttr('style');
    }

    this.items.forEach(function (item) {
      item.removeAttr('style');
      item.removeClass(animateCls);
    });

    isInitialized = false;
  };

  // API

  this.setContainer = function (container) {
    containerElement = container;

    if (!this.isEnabled) {
      return;
    }

    containerElement.css(options.stack ? stackContainerStyles : containerStyles);

    this.init();
  };

  this.addItem = function (item) {
    this.items.push(item);

    if (!this.isEnabled) {
      return;
    }

    item.css(options.stack ? stackItemStyles : itemStyles);
    if (options.stack) {
      item.css({
        'opacity': 0,
        'z-index': this.items.indexOf(item)
      });
    } else  {
      item.css(getSlideTransform(this.items.length - 1, -100 * this.currentItemIndex));
    }
  };

  this.removeItem = function (item) {
    this.items.splice(this.items.indexOf(item), 1);
  };

  this.showItem = function (itemIndex, animate) {
    if (options.stack) {
      const numberOfItems = this.items.length;
      const prevIdx = this.currentItemIndex;
      const currentIdx = (itemIndex % numberOfItems + numberOfItems) % numberOfItems;

      if (animate) {
        containerElement.addClass(animateCls);
        this.items[prevIdx].addClass(ngAnimateClass);
        this.items[currentIdx].addClass(ngAnimateClass);
      }

      const promises = [
        $animate.animate(this.items[prevIdx], {}, { opacity: 0 }),
        $animate.animate(this.items[currentIdx], {}, { opacity: 1 })
      ];

      $q.all(promises)
        .finally(() => {
          containerElement.removeClass(animateCls);
          this.items[prevIdx].removeClass(ngAnimateClass);
          this.items[currentIdx].removeClass(ngAnimateClass);
        });

      this.currentItemIndex = currentIdx;
    } else {
      this.currentItemIndex = Math.max(0, Math.min(itemIndex, this.items.length - 1));
      setOffset(this.items, -100 * this.currentItemIndex, animate);
    }
  };

  this.prevItem = function () {
    this.showItem(this.currentItemIndex - 1, true);
  };

  this.nextItem = function () {
    this.showItem(this.currentItemIndex + 1, true);
  };

  $attrs.$observe('saCarousel', (isEnabled) => {
    this.isEnabled = isEnabled !== String(false);

    if (this.isEnabled ) {
      this.init();
    } else {
      this.destroy();
    }
  });
};

export default function saCarousel() {
  return {
    restrict: 'A',
    bindToController: true,
    controller: saCarouselCtrl
  };
}



// WEBPACK FOOTER //
// ./app/src/common/carousel/carousel.directive.js